/*
  VEZARRO - panier coulissant.
  Le HTML vient de sections/cart-drawer.liquid, renvoye par la Section Rendering API
  en meme temps que chaque ajout ou modification : une seule requete par action.
  Les requetes passent dans une file pour que deux clics rapides ne se croisent jamais.
*/
(function () {
  'use strict';

  var SID = 'cart-drawer';
  var TIMER_KEY = 'vzcd_timer_end';
  var PROT_OPTOUT = 'vzcd_prot_optout';
  var protAdding = false;
  var protBlocked = false;
  var html = document.documentElement;
  var queue = Promise.resolve();
  var recoCache = {};
  var timerId = null;
  var lastFocus = null;
  var isOpen = false;

  function root() { return document.getElementById('VZCartDrawer'); }
  function enabled() { var r = root(); return !!r && r.getAttribute('data-enabled') === 'true'; }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- Protection : memoire du refus ---------- */
  var optOut = {
    get: function () {
      try { if (localStorage.getItem(PROT_OPTOUT) === '1') return true; } catch (e) {}
      return store.get(PROT_OPTOUT) === '1';
    },
    set: function () {
      try { localStorage.setItem(PROT_OPTOUT, '1'); } catch (e) {}
      store.set(PROT_OPTOUT, '1');
    },
    del: function () {
      try { localStorage.removeItem(PROT_OPTOUT); } catch (e) {}
      store.del(PROT_OPTOUT);
    }
  };

  /* ---------- Prix ---------- */
  function money(cents) {
    var r = root();
    var fmt = (r && r.getAttribute('data-money-format')) || '{{amount_with_comma_separator}} €';
    var parts = (cents / 100).toFixed(2).split('.');
    var i = parts[0], d = parts[1];
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var k = m ? m[1] : 'amount';
    var s;
    if (k.indexOf('no_decimals_with_comma') > -1) s = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (k.indexOf('no_decimals') > -1) s = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (k.indexOf('comma') > -1) s = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
    else s = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
    return m ? fmt.replace(m[0], s) : s;
  }

  /* ---------- Ouverture / fermeture ---------- */
  function open() {
    var r = root();
    if (!r) return;
    if (!isOpen) lastFocus = document.activeElement;
    isOpen = true;
    r.hidden = false;
    void r.offsetWidth;
    r.classList.add('is-open');
    html.classList.add('vzcd-lock');
    var panel = r.querySelector('.vzcd__panel');
    if (panel) { try { panel.focus({ preventScroll: true }); } catch (e) {} }
    afterRender(r);
  }

  function close() {
    var r = root();
    isOpen = false;
    clearInterval(timerId);
    html.classList.remove('vzcd-lock');
    if (!r) return;
    r.classList.remove('is-open');
    setTimeout(function () { if (!isOpen) r.hidden = true; }, 360);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Rendu ---------- */
  function render(markup) {
    var cur = root();
    if (!cur || !markup) return;
    var fresh = new DOMParser().parseFromString(markup, 'text/html').getElementById('VZCartDrawer');
    if (!fresh) return;

    var oldBody = cur.querySelector('.vzcd__body');
    var scroll = oldBody ? oldBody.scrollTop : 0;
    var oldFill = cur.querySelector('.vzcd__ship-fill');
    var oldWidth = oldFill ? oldFill.style.width : null;
    var hadFocus = cur.contains(document.activeElement);

    for (var i = 0; i < fresh.attributes.length; i++) {
      var a = fresh.attributes[i];
      if (a.name !== 'hidden' && a.name !== 'class') cur.setAttribute(a.name, a.value);
    }
    cur.className = fresh.className + (isOpen ? ' is-open' : '');

    var panel = cur.querySelector('.vzcd__panel');
    var next = document.importNode(fresh.querySelector('.vzcd__panel'), true);
    panel.parentNode.replaceChild(next, panel);

    var body = next.querySelector('.vzcd__body');
    if (body) body.scrollTop = scroll;

    var fill = next.querySelector('.vzcd__ship-fill');
    if (fill && oldWidth !== null && oldWidth !== fill.style.width) {
      var target = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = oldWidth;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = target;
    }

    if (hadFocus) { try { next.focus({ preventScroll: true }); } catch (e) {} }
    afterRender(cur);
  }

  function afterRender(r) {
    var count = parseInt(r.getAttribute('data-count'), 10) || 0;
    bubble(count);
    if (count === 0) store.del(TIMER_KEY);

    // une protection seule dans le panier n'a pas de sens : on la retire
    var protKey = r.getAttribute('data-prot-key');
    if (protKey && count === 0) change(protKey, 0);

    protAuto(r, count, protKey);

    if (isOpen) { timer(r); recos(r); }
  }

  /*
    Protection pre-cochee : des qu il y a au moins un article et qu elle n est pas deja
    dans le panier, on l ajoute. On ne le refait pas si le client l a decochee lui-meme
    (optOut) ni si l ajout a echoue une fois (produit depublie, rupture...).
  */
  function protAuto(r, count, protKey) {
    if (count === 0) { protBlocked = false; return; }
    if (protKey || protAdding || protBlocked || optOut.get()) return;
    var sw = r.querySelector('[data-vzcd-protection]');
    if (!sw || sw.getAttribute('data-auto') === 'off') return;
    var vid = parseInt(sw.getAttribute('data-vzcd-protection'), 10);
    if (!vid) return;
    protAdding = true;
    sw.setAttribute('aria-checked', 'true');
    setTimeout(function () {
      addItems([{ id: vid, quantity: 1 }]).then(
        function () { protAdding = false; },
        function () { protAdding = false; protBlocked = true; refresh(); }
      );
    }, 0);
  }

  function bubble(n) {
    var links = document.querySelectorAll('a.header-icon[href$="/cart"], [data-vz-cart-open]');
    for (var i = 0; i < links.length; i++) {
      var b = links[i].querySelector('.cart-count');
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'cart-count'; links[i].appendChild(b); }
        b.textContent = n;
      } else if (b) {
        b.parentNode.removeChild(b);
      }
    }
  }

  /* ---------- Requetes ---------- */
  function busy(on) { var r = root(); if (r) r.classList.toggle('is-busy', on); }

  function post(url, payload) {
    var run = function () {
      busy(true);
      var opts = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } };
      if (payload instanceof FormData) {
        payload.append('sections', SID);
        payload.append('sections_url', location.pathname);
        opts.body = payload;
      } else {
        payload.sections = SID;
        payload.sections_url = location.pathname;
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(payload);
      }
      return fetch(url, opts)
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok || (data && data.status && data.status >= 400)) {
              var err = new Error((data && (data.description || data.message)) || 'Error');
              err.status = res.status;
              throw err;
            }
            return data;
          });
        })
        .then(function (data) {
          if (data && data.sections && data.sections[SID]) { render(data.sections[SID]); return data; }
          return refresh().then(function () { return data; });
        })
        .then(function (data) { busy(false); return data; }, function (err) { busy(false); throw err; });
    };
    var p = queue.then(run, run);
    queue = p.catch(function () {});
    return p;
  }

  function refresh() {
    return fetch(location.pathname + '?sections=' + SID, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d[SID]) render(d[SID]); })
      .catch(function () {});
  }

  function change(key, qty) {
    if (!key) return Promise.resolve();
    return post('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .catch(function (err) { return refresh().then(function () { showError(err); }); });
  }

  function addItems(items) {
    return post('/cart/add.js', { items: items });
  }

  function showError(err) {
    var r = root();
    var el = r && r.querySelector('[data-vzcd-error]');
    if (!el) return;
    el.textContent = (err && err.message) || String(err);
    el.hidden = false;
    clearTimeout(showError.t);
    showError.t = setTimeout(function () { var e = root() && root().querySelector('[data-vzcd-error]'); if (e) e.hidden = true; }, 6000);
  }

  /* ---------- Minuteur ---------- */
  function timer(r) {
    clearInterval(timerId);
    var el = r.querySelector('[data-vzcd-timer]');
    if (!el) return;
    var mins = parseFloat(el.getAttribute('data-minutes')) || 10;
    var end = parseInt(store.get(TIMER_KEY), 10);
    if (!end) { end = Date.now() + mins * 60000; store.set(TIMER_KEY, end); }
    var val = el.querySelector('[data-vzcd-timer-value]');
    function tick() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor(left / 1000) % 60;
      if (val) val.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) {
        clearInterval(timerId);
        var exp = el.getAttribute('data-expired');
        if (exp) { var t = el.querySelector('[data-vzcd-timer-text]'); if (t) t.textContent = exp; }
        else el.hidden = true;
      }
    }
    tick();
    timerId = setInterval(tick, 1000);
  }

  /* ---------- Produits suggeres automatiques ---------- */
  function recos(r) {
    var boxes = r.querySelectorAll('[data-vzcd-recos]');
    Array.prototype.forEach.call(boxes, function (box) {
      var pid = box.getAttribute('data-product-id');
      if (!pid) return;
      var intent = box.getAttribute('data-intent') === 'complementary' ? 'complementary' : 'related';
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 3;
      var key = pid + ':' + intent;

      var draw = function (products) {
        var list = box.querySelector('[data-vzcd-recos-list]');
        var tpl = r.querySelector('#VZCDCardTpl');
        if (!list || !tpl || !tpl.content) return;
        var exclude = (box.getAttribute('data-exclude') || '').split(',');
        var label = box.getAttribute('data-button') || '+';
        var showCompare = box.getAttribute('data-compare') === 'true';
        list.textContent = '';
        var n = 0;
        products.forEach(function (p) {
          if (n >= limit || !p.available || exclude.indexOf(String(p.id)) > -1) return;
          if ((p.tags || []).indexOf('vz-nascosto') > -1) return;
          var vars = (p.variants || []).filter(function (v) { return v.available; });
          if (!vars.length) return;
          var node = tpl.content.firstElementChild.cloneNode(true);
          Array.prototype.forEach.call(node.querySelectorAll('[data-f~="link"]'), function (a) { a.href = p.url; });
          node.querySelector('[data-f~="title"]').textContent = p.title;
          var img = node.querySelector('[data-f="img"]');
          if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240'; img.alt = p.title; }
          else img.parentNode.removeChild(img);
          node.querySelector('[data-f="price"]').textContent = money(vars[0].price);
          var cmp = node.querySelector('[data-f="compare"]');
          if (showCompare && vars[0].compare_at_price > vars[0].price) cmp.textContent = money(vars[0].compare_at_price);
          if (vars.length > 1) {
            var sel = document.createElement('select');
            sel.className = 'vzcd__card-select';
            sel.setAttribute('aria-label', p.title);
            vars.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.title; sel.appendChild(o); });
            node.querySelector('.vzcd__card-body').appendChild(sel);
          }
          var btn = node.querySelector('[data-vzcd-add]');
          btn.setAttribute('data-vzcd-add', vars[0].id);
          btn.textContent = label;
          list.appendChild(node);
          n++;
        });
        box.hidden = n === 0;
      };

      if (recoCache[key]) return draw(recoCache[key]);
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=' + (limit + 4) + '&intent=' + intent)
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (d) { recoCache[key] = (d && d.products) || []; var cur = root(); if (cur && cur.contains(box)) draw(recoCache[key]); })
        .catch(function () {});
    });
  }

  /* ---------- Ajout depuis la fiche produit ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !enabled() || !form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var btn = e.submitter || form.querySelector('[name="add"], [type="submit"]');
    if (btn) btn.classList.add('vzcd-loading');
    var r = root();
    post('/cart/add.js', new FormData(form))
      .then(function () {
        if (!r || r.getAttribute('data-open-on-add') !== 'false') open();
      }, function (err) {
        open();
        showError(err);
      })
      .then(function () { if (btn) btn.classList.remove('vzcd-loading'); });
  });

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var r = root();

    var opener = t.closest('[data-vz-cart-open], a.header-icon[href$="/cart"]');
    if (opener && enabled() && !onCartPage() && !(r && r.contains(opener)) && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      open();
      return;
    }

    if (!r || !r.contains(t)) return;

    if (t.closest('[data-vzcd-close]')) { e.preventDefault(); close(); return; }

    var st = t.closest('[data-vzcd-step]');
    if (st) {
      e.preventDefault();
      var k = st.getAttribute('data-key');
      var input = st.parentNode.querySelector('[data-vzcd-input]');
      var nextQty = Math.max(0, (parseInt(input && input.value, 10) || 0) + (parseInt(st.getAttribute('data-vzcd-step'), 10) || 0));
      if (input) input.value = nextQty;
      change(k, nextQty);
      return;
    }

    var q = t.closest('[data-vzcd-qty]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-vzcd-qty'), parseInt(q.getAttribute('data-qty'), 10) || 0); return; }

    var rm = t.closest('[data-vzcd-remove]');
    if (rm) { e.preventDefault(); change(rm.getAttribute('data-vzcd-remove'), 0); return; }

    var add = t.closest('[data-vzcd-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('.vzcd__card');
      var sel = card && card.querySelector('select');
      var vid = parseInt(sel ? sel.value : add.getAttribute('data-vzcd-add'), 10);
      if (!vid) return;
      add.disabled = true;
      addItems([{ id: vid, quantity: 1 }]).catch(function (err) { add.disabled = false; showError(err); });
      return;
    }

    var sw = t.closest('[data-vzcd-protection]');
    if (sw) {
      e.preventDefault();
      var wasOn = sw.getAttribute('aria-checked') === 'true';
      sw.setAttribute('aria-checked', wasOn ? 'false' : 'true');
      if (wasOn) { optOut.set(); } else { optOut.del(); }
      var req = wasOn
        ? change(sw.getAttribute('data-key'), 0)
        : addItems([{ id: parseInt(sw.getAttribute('data-vzcd-protection'), 10), quantity: 1 }]);
      req.catch(function (err) { refresh().then(function () { showError(err); }); });
      return;
    }

    var co = t.closest('[data-vzcd-checkout]');
    if (co) co.classList.add('vzcd-loading');
  });

  document.addEventListener('change', function (e) {
    var t = e.target, r = root();
    if (!r || !t || !r.contains(t)) return;
    if (t.hasAttribute('data-vzcd-input')) {
      change(t.getAttribute('data-vzcd-input'), parseInt(t.value, 10) || 0);
    } else if (t.hasAttribute('data-vzcd-note')) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }
  });

  /* ---------- Clavier ---------- */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-vzcd-input')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key !== 'Tab') return;
    var panel = root() && root().querySelector('.vzcd__panel');
    if (!panel) return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Editeur de theme ---------- */
  function mine(e) { return !!(e.detail && e.detail.sectionId === SID); }
  document.addEventListener('shopify:section:select', function (e) { if (mine(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (mine(e)) close(); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!mine(e)) return;
    open();
    var b = document.querySelector('#VZCartDrawer [data-shopify-editor-block*="' + e.detail.blockId + '"]');
    if (b) setTimeout(function () { b.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 360);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (!mine(e)) return;
    if (isOpen) { isOpen = false; open(); } else afterRender(root());
  });

  /* Retour arriere depuis le paiement : le panier a pu changer */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.VZCart = {
    open: open,
    close: close,
    refresh: refresh,
    add: addItems,
    change: change,
    enabled: enabled
  };

  if (root()) afterRender(root());
})();
